<template>
    <div id="corporate-view">
        <div class="row g-0 red-color justify-content-center text-white mt-4 pt-5 pb-5">
            <div class="col-8 text-left" style="font-size: 1.15rem; line-height: 1.5;">
                <h5 class="fw-bold">{{ title }} </h5>
                <h5 class="mb-5 fw-bold">{{ subTitle }} </h5>
                <div class="agency-corporate-main-font-size">
                    <p v-for="item in content" :key="item" class="mb-0">{{ item }}</p>
                </div>
            </div>
        </div>

        <div class="bg-black text-center text-white mt-4 pb-2 pt-3 fs-3">
            <div class="mb-0 pb-0 agency-signature-main">{{ signatureMain }} </div>
            <div class="mb-0 pt-0">{{ websiteUrl }} </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import { useLanguageStore } from "@/stores/language";

import { TEXT_KEYS } from "@/constants";

@Options({
  components: {
  }
})
export default class Home extends Vue {
  languageStore = useLanguageStore()

    content = [
        this.languageStore.text(TEXT_KEYS.CORPORATE_CONTENT_1),
        this.languageStore.text(TEXT_KEYS.CORPORATE_CONTENT_2),
        this.languageStore.text(TEXT_KEYS.CORPORATE_CONTENT_3),
        this.languageStore.text(TEXT_KEYS.CORPORATE_CONTENT_4),
        this.languageStore.text(TEXT_KEYS.CORPORATE_CONTENT_5),
        this.languageStore.text(TEXT_KEYS.CORPORATE_CONTENT_6)
    ]

    get title() {
        return this.languageStore.text(TEXT_KEYS.CORPORATE_TITLE)
    }

    get subTitle() {
        return this.languageStore.text(TEXT_KEYS.CORPORATE_SUB_TITLE)
    }

    get signatureMain() {
        return this.languageStore.text(TEXT_KEYS.CORPORATE_SIGNATURE_MAIN)
    }

    get websiteUrl() {
        return this.languageStore.text(TEXT_KEYS.WEBSITE_URL)
    }
}
</script>

<style lang="stylus">
</style>